import React, { useState } from 'react';
import ViewToggle from './ViewToggle';
import { getPersonImage, getPersonBgImage } from '../personImageConfig';

const ScoreSummary = ({
  totalScore,
  scoreColor,
  scoreStatus,
  bmi,
  bmiStatus,
  viewMode,
  onViewModeChange,
  age,
  gender,
  ageGroupMetadata,
  personImageReady,
  onInfoClick,
  subtitle = '',
}) => {
  const [personImgLoaded, setPersonImgLoaded] = useState(false);

  const personImage = getPersonImage({ age, gender, bmi, ageGroupMetadata });
  const bgImage = getPersonBgImage(gender);
  const showPerson = personImageReady && personImgLoaded;

  return (
    <div className='summary-container'>
      <img className='bg-image' src={bgImage} alt='' />

      <div className='detail-container'>
        <div className='title'>
          คะแนนสุขภาพ
          <img
            className='info-icon'
            src='/images/nutrition-and-rehabilitation/information-green.svg'
            alt='info'
            onClick={onInfoClick}
          />
        </div>
        <div className='percent-value'>
          <span className='value' style={scoreColor ? { color: scoreColor } : undefined}>{totalScore}</span>
          <span className='unit'>%</span>
          {scoreStatus && (
            <span className='score-status' style={scoreColor ? { color: scoreColor } : undefined}>{scoreStatus}</span>
          )}
        </div>
        <div className='subtitle'>{subtitle || '\u00A0'}</div>
        <div className='bmi-label'>BMI</div>
        <div className='bmi-info'>
          <span className='bmi-value'>{bmi || '-'}</span>
          <span className='bmi-status'>{bmiStatus}</span>
        </div>
        <ViewToggle viewMode={viewMode} onChange={onViewModeChange} />
      </div>
      <div className='person-image'>
        {personImageReady && (
          <img
            className='person-img'
            src={personImage}
            alt=''
            style={showPerson ? undefined : { visibility: 'hidden' }}
            onLoad={() => setPersonImgLoaded(true)}
          />
        )}
        {!showPerson && (
          <div className='person-img-placeholder' />
        )}
      </div>
    </div>
  );
};

export default ScoreSummary;
